import { AiAutomationConfig } from 'shared/api/requests/aiAutomation/schemas'

export enum LoaderStatus {
  NOT_LOADED = 'NOT_LOADED',
  LOADED = 'LOADED',
  DASHBOARD_LOADING = 'DASHBOARD_LOADING',
  FAQ_LIVE_LOADING = 'FAQ_LIVE_LOADING',
  KNOWLEDGE_EDITOR_LOADING = 'KNOWLEDGE_EDITOR_LOADING',
}

export interface AiAlwaysOnAutomationsState {
  config: AiAutomationConfig
  selectedKnowledgeChunkIndex: number | null
  loaderStatus: LoaderStatus
}
